export class ChangePhoneNumberConfirmOtpRequest {
    sessionToken: string = '';
    code: string = '';
  }